/* eslint-disable @typescript-eslint/no-unused-vars */
import 'keen-slider/keen-slider.min.css'
import React, { useState } from 'react'

import CourseProgressCard from '../CourseProgressCard'
import { Container } from './styles'
import { useKeenSlider } from 'keen-slider/react'

interface RecentViewProps {
  courses: any[]
}

const RecentView: React.FC<RecentViewProps> = ({ courses }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0)

  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    mode: 'snap',

    loop: courses.length > Math.floor(window.innerWidth / 400),
    slides: { perView: 1, spacing: 5, origin: 'auto' },
    breakpoints: {
      '(max-width: 500px)': {
        slides: { perView: 1, spacing: 5 },
      },
      '(min-width: 1000px)': {
        slides: { perView: 4, spacing: 10 },
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel)
    },
  })

  return (
    <>
      <Container>
        <h2 className="title">{!courses.length ? '' : 'Visto Recentemente'}</h2>
        <div ref={sliderRef} className="keen-slider">
          {courses.length ? (
            <>
              {courses.map(
                (item, idx) =>
                  item && (
                    <div className={`keen-slider__slide number-slide${idx}`} key={idx}>
                      <CourseProgressCard
                        name={item?.name}
                        percentage={item.progress}
                        numberOfModules={item.modules || item.children?.length}
                        icon={item.icon}
                        courseId={item.courseId}
                        isFreemium={item?.isFreemium}
                      />
                    </div>
                  )
              )}
            </>
          ) : (
            ''
          )}
        </div>
      </Container>
    </>
  )
}

export default RecentView
